module.exports = __webpack_public_path__ + "static/media/27a Half Guard.f60a97c2.jpg";